export default __webpack_public_path__ + "static/media/paneles.a7ce1928.svg";